import * as React from "react"
const IconArrange = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 19}
        height={props.height || 19}
        viewBox="0 0 19 19"
        fill="none"
        {...props}
    >
        <path
            stroke={props.stroke || "#A4A7AE"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={props.strokeWidth || 1.667}
            d="m3.333 6.667-2.5 2.5m0 0 2.5 2.5m-2.5-2.5H17.5M6.666 3.333l2.5-2.5m0 0 2.5 2.5m-2.5-2.5V17.5m2.5-2.5-2.5 2.5m0 0-2.5-2.5M15 6.667l2.5 2.5m0 0-2.5 2.5"
        />
    </svg>
)
export default IconArrange
